import styled from "styled-components";
import { BotaoIcone, Conteudo } from "../styles";

export const ContainerVazio = styled(Conteudo)`
    text-align: center !important;
    margin-bottom: 1.5rem !important;
`;

export const IconeDocumentoVazio = styled(BotaoIcone)`
    justify-content: center !important;
    margin-top: 3rem !important;
    margin-bottom: 1.5rem !important;
`;

export const Paragrafo = styled.p`
    color: ${(props: any) => props.theme.colors.interfaceText} !important;
    margin-bottom: 0.5rem !important;
`;

export const ParagrafoMuted = styled.p`
    color: ${(props: any) => props.theme.colors.c64748b} !important;
    margin-bottom: 1.5rem !important;
`;
